import Firebase from 'firebase/app';
import { prepareDocForCreate } from './helpers/firestoreHelpers';

const createUser = (authUser, referral) => {
  return Firebase.firestore()
    .collection(`users`).doc(authUser.uid)
    .set({
      email: authUser.email,
      referral,
      subscribed: false,
    })
    .catch( error => {
      alert(`Whoops, couldn't create user: ${error.message}`)
    })
}

export default createUser;
